"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SvgIcon_1 = __importDefault(require("@material-ui/core/es/SvgIcon/SvgIcon"));
var BerserkerIcon = /** @class */ (function (_super) {
    __extends(BerserkerIcon, _super);
    function BerserkerIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BerserkerIcon.prototype.render = function () {
        return (react_1.default.createElement(SvgIcon_1.default, null,
            react_1.default.createElement("svg", null,
                react_1.default.createElement("path", { d: "m 6.4973977,14.47025 c 1.28095,-2.62729 2.329,-4.7950558 2.329,-4.8172588 0,-0.0222 -1.20414,-0.08552 -2.67586,-0.140701 l -2.67587,-0.100333 3.19012,-3.2907494 c 1.75456,-1.809911 3.8536103,-3.9784294 4.6645503,-4.8189294 0.8895,-0.92193003 1.42568,-1.39217302 1.35154,-1.18534503 -0.0676,0.188559 -0.83908,1.77919903 -1.71442,3.53475543 -0.87534,1.755555 -1.5915303,3.252031 -1.5915303,3.325501 0,0.07347 0.1697103,0.136081 0.3771203,0.139133 0.8162,0.01201 5.24878,0.363538 5.30604,0.420795 0.0335,0.03348 -0.65557,0.830618 -1.5312,1.7714234 -2.24303,2.4099538 -6.9214103,7.3881068 -8.2446803,8.7729598 l -1.11381,1.16564 z m -0.41369,4.65231 c 0,-0.04454 0.63218,-0.460772 3.5654903,-2.347556 0.79195,-0.509402 1.47077,-0.95425 1.50848,-0.98855 0.0377,-0.0343 -0.22231,-0.318755 -0.57783,-0.63212 l -0.64639,-0.569752 2.80625,-1.325301 c 1.54344,-0.728916 2.80626,-1.304883 2.80626,-1.279928 0,0.02496 -0.66339,0.614264 -1.47419,1.309575 -0.81081,0.695311 -1.49209,1.309543 -1.51397,1.36496 -0.0219,0.05542 0.27485,0.302651 0.65939,0.549407 0.38454,0.246758 0.64689,0.500917 0.58301,0.564799 -0.0639,0.06388 -1.34797,0.647885 -2.85353,1.297782 -1.5055603,0.6499 -3.2156403,1.388784 -3.8001803,1.641965 -0.58453,0.253182 -1.06279,0.439805 -1.06279,0.414719 z m -3.23655,-2.658591 -0.41487,-2.016518 -0.47128,0.0049 c -0.25921,0.0027 -0.75585,0.0515 -1.10366002,0.108401 l -0.63236998,0.103465 1.03252,-3.502302 c 0.56788,-1.9262658 1.04774,-3.4869502 1.06637,-3.4681872 0.0186,0.01876 -0.10514,1.175757 -0.27503,2.5710972 -0.16989,1.395339 -0.27263,2.576858 -0.22831,2.625595 0.0443,0.04874 0.46781,0.02455 0.94107,-0.05375 0.47327,-0.0783 0.88551,-0.117333 0.9161,-0.08674 0.0633,0.06325 -0.29677,5.611619 -0.3688,5.683645 -0.0258,0.02578 -0.23356,-0.860558 -0.46174,-1.969644 z" }))));
    };
    return BerserkerIcon;
}(react_1.Component));
exports.default = BerserkerIcon;



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/BerserkerIcon.tsx
// module id = 785
// module chunks = 0